// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__6cpUF","abort":"style_abort__3qMso","register":"style_register__2wkEC","valid":"style_valid__3Ly8m","warning":"style_warning__1V5e6"};